var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBloodHomeIcon = function SvgBloodHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 8 6.5-4L16 8M14.143 10v4.572c0 .236-.178.428-.398.428h-8.49c-.22 0-.398-.192-.398-.428V10",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBloodHomeIcon;